import { Routes } from '@angular/router';

export const newsRoutes: Routes = [
  // {
  //   path: 'noticias',
  //   canActivate: [permissionGuard],
  //   data: {
  //     permission: CMS_PERMISSIONS.news.viewAny,
  //   },
  //   loadComponent: () => import('./pages/list/list').then((m) => m.NewsList),
  // },
  // {
  //   path: 'noticias/crear',
  //   canActivate: [permissionGuard],
  //   data: {
  //     permission: CMS_PERMISSIONS.news.create,
  //   },
  //   loadComponent: () => import('./pages/form/form').then((m) => m.NewsForm),
  // },
  // {
  //   path: 'noticias/:id/editar',
  //   canActivate: [permissionGuard],
  //   data: {
  //     permission: CMS_PERMISSIONS.news.update,
  //   },
  //   loadComponent: () => import('./pages/form/form').then((m) => m.NewsForm),
  // },
];
